import { render } from "./ManageFeatures.vue?vue&type=template&id=7aa2e754&scoped=true"
import script from "./ManageFeatures.vue?vue&type=script&lang=js"
export * from "./ManageFeatures.vue?vue&type=script&lang=js"

import "./ManageFeatures.vue?vue&type=style&index=0&id=7aa2e754&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa2e754"]])

export default __exports__